/**
 * Re-export facade for the active-cycle test fixtures, which now live in
 * `../test-fixtures/activeCycleFixtures`.
 *
 * The fixtures are the state layer behind the `dev_*` URL params that the
 * visual-evidence capture routes drive, so they are test infrastructure rather
 * than product code. This module keeps the historical import path working for
 * the hooks and screens that read the fixtures.
 */
export * from "../test-fixtures/activeCycleFixtures";
